<script lang="ts">
	const {
		mdImage,
		smImage,
		size,
		altText
	}: { mdImage: string; smImage: string; size: { width: number; height: number }; altText: string } = $props();
</script>

<picture class="absolute inset-0 z-0">
	<source media="(max-width: 767px)" srcset={smImage} />
	<source media="(min-width: 768px)" srcset={mdImage} />
	<img
		src={smImage}
		alt={altText}
		class="h-full w-full object-cover"
		width={size.width}
		height={size.height}
		fetchpriority="high"
		loading="eager"
	/>
</picture>
<div class="absolute inset-0 bg-black/50"></div>
<div class="absolute inset-x-0 bottom-0 h-48 bg-linear-to-t from-base-100 to-transparent"></div>
